import { render } from "./Saldo.vue?vue&type=template&id=1cbf23f4"
import script from "./Saldo.vue?vue&type=script&lang=js"
export * from "./Saldo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__